import { formatINR } from '../../../shared/utils/formatters';
import React from 'react'
import { Card, Table, Tag, Space, Typography, Row, Col, Statistic } from 'antd'
import { DollarOutlined } from '@ant-design/icons'
import { useQuery } from '@tanstack/react-query'
import { apiClient } from '../../../shared/api/axios-instance'

const { Title } = Typography

export const SubscriptionInvoicesScreen: React.FC = () => {
    const { data, isLoading } = useQuery({
        queryKey: ['subscription-invoices'],
        queryFn: async () => {
            const response = await apiClient.get('/admin/subscription-invoices')
            return response.data.data
        }
    })

    const columns = [
        { title: 'Invoice #', dataIndex: 'invoice_number', key: 'invoice_number' },
        { title: 'Merchant', dataIndex: 'merchant_name', key: 'merchant_name' },
        { 
            title: 'Base Amount', 
            dataIndex: 'subtotal', 
            key: 'subtotal',
            render: (val: any) => formatINR(Number(val || 0).toFixed(2))
        },
        { 
            title: 'Tax Amount', 
            dataIndex: 'tax_amount', 
            key: 'tax_amount',
            render: (val: any) => formatINR(Number(val || 0).toFixed(2))
        },
        { 
            title: 'Total Amount', 
            dataIndex: 'total_amount', 
            key: 'total_amount',
            render: (val: any) => formatINR(Number(val || 0).toFixed(2))
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (status: string) => (
                <Tag color={status === 'paid' ? 'green' : 'gold'}>{status.toUpperCase()}</Tag>
            )
        },
        { title: 'Issued At', dataIndex: 'issued_at', key: 'issued_at', render: (d: string) => new Date(d).toLocaleDateString() },
        { title: 'Due Date', dataIndex: 'due_date', key: 'due_date', render: (d: string) => new Date(d).toLocaleDateString() },
    ]

    const totalRevenue = data?.filter((i: any) => i.status === 'paid')
        .reduce((sum: number, i: any) => sum + parseFloat(i.total_amount), 0) || 0

    return (
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <Title level={2}>Subscription Invoices</Title>

            <Row gutter={16}>
                <Col span={8}>
                    <Card>
                        <Statistic
                            title="Total Paid Revenue"
                            value={totalRevenue}
                            precision={2}
                            prefix={<DollarOutlined />}
                            valueStyle={{ color: '#3f8600' }}
                        />
                    </Card>
                </Col>
            </Row>

            <Card>
                <Table 
                    columns={columns} 
                    dataSource={data} 
                    loading={isLoading}
                    rowKey="id"
                />
            </Card>
        </Space>
    )
}
